// // D:\MAHAL(UPDATED)-NEW11-04\MAHAL kdsagakhjqsdfk\src\pages\Support\Routing.js

// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import {
//   FaChartLine,
//   FaSpinner,
//   FaSyncAlt,
//   FaSitemap,
//   FaProjectDiagram,
//   FaSearch,
//   FaBolt,
//   FaClock,
//   FaUserShield,
//   FaExclamationTriangle,
//   FaLayerGroup,
//   FaSave,
//   FaRetweet,
//   FaInfoCircle,
//   FaCheckCircle,
//   FaCogs,
//   FaRegChartBar,
//   FaFilter,
//   FaArrowRight,
//   FaArrowUp,
//   FaArrowDown
// } from "react-icons/fa";

// // import "./Routing.css"
// import "./Support.css";

// const API = "https://api.mahal.qa/api/v1/admin/support";

// const TABS = [

//   { key: "overview", label: "Overview", icon: <FaRegChartBar /> },
//   { key: "map", label: "Category Routing", icon: <FaProjectDiagram /> },
//   { key: "simulate", label: "Simulator", icon: <FaBolt /> },
//   { key: "health", label: "Queue Health", icon: <FaLayerGroup /> },
//   { key: "chain", label: "Escalation Chain", icon: <FaSitemap /> },
//   { key: "actions", label: "Actions", icon: <FaCogs /> }

// ];

// function formatNumber(value) {
//   const n = Number(value || 0);
//   return new Intl.NumberFormat("en-IN").format(n);
// }

// function formatHours(value) {
//   const n = Number(value || 0);
//   if (!Number.isFinite(n)) return "0h";
//   return `${n.toFixed(1)}h`;
// }

// function getRole() {
//   return (localStorage.getItem("admin_role") || "")
//     .trim()
//     .replace(/\s+/g, "_")
//     .toUpperCase();
// }

// export default function Routing() {
//   const token = localStorage.getItem("admin_token");
//   const role = getRole();

//   const [loading, setLoading] = useState(true);
//   const [refreshing, setRefreshing] = useState(false);
//   const [activeTab, setActiveTab] = useState("overview");

//   const [notice, setNotice] = useState(null);

//   const [overview, setOverview] = useState([]);
//   const [categoryMap, setCategoryMap] = useState([]);
//   const [liveHealth, setLiveHealth] = useState([]);
//   const [escalationChain, setEscalationChain] = useState([]);

//   const [search, setSearch] = useState("");
//   const [savingRowId, setSavingRowId] = useState(null);

//   const [simulateForm, setSimulateForm] = useState({
//     category_id: "",
//     priority: "normal",
//     escalation_level: 0
//   });

//   const [simulateResult, setSimulateResult] = useState(null);
//   const [simulating, setSimulating] = useState(false);
//   const [rebalanceLoading, setRebalanceLoading] = useState(false);

//   const headers = useMemo(
//     () => ({
//       Authorization: `Bearer ${token}`
//     }),
//     [token]
//   );

//   const showNotice = useCallback((type, text) => {
//     setNotice({ type, text });
//     window.clearTimeout(showNotice._timer);
//     showNotice._timer = window.setTimeout(() => {
//       setNotice(null);
//     }, 350000);
//   }, []);
//   showNotice._timer = showNotice._timer || null;

//   const loadRoutingData = useCallback(
//     async (silent = false) => {
//       if (!token) return;

//       try {
//         if (silent) setRefreshing(true);
//         else setLoading(true);

//         const requests = [
//           axios.get(`${API}/routing/overview`, { headers }),
//           axios.get(`${API}/routing/category-map`, { headers }),
//           axios.get(`${API}/routing/live-health`, { headers }),
//           axios.get(`${API}/routing/escalation-chain`, { headers })
//         ];

//         const [overviewRes, mapRes, healthRes, chainRes] = await Promise.allSettled(requests);

//         if (overviewRes.status === "fulfilled") {
//           setOverview(Array.isArray(overviewRes.value.data) ? overviewRes.value.data : []);
//         } else {
//           setOverview([]);
//         }

//         if (mapRes.status === "fulfilled") {
//           setCategoryMap(Array.isArray(mapRes.value.data) ? mapRes.value.data : []);
//         } else {
//           setCategoryMap([]);
//         }

//         if (healthRes.status === "fulfilled") {
//           setLiveHealth(Array.isArray(healthRes.value.data) ? healthRes.value.data : []);
//         } else {
//           setLiveHealth([]);
//         }

//         if (chainRes.status === "fulfilled") {
//           setEscalationChain(Array.isArray(chainRes.value.data) ? chainRes.value.data : []);
//         } else {
//           setEscalationChain([]);
//         }

//         if (
//           overviewRes.status === "rejected" ||
//           mapRes.status === "rejected" ||
//           healthRes.status === "rejected" ||
//           chainRes.status === "rejected"
//         ) {
//           showNotice("warn", "Some routing data could not be loaded.");
//         }
//       } catch (error) {
//         console.error("Routing load failed", error);
//         showNotice("error", "Failed to load routing data.");
//       } finally {
//         setLoading(false);
//         setRefreshing(false);
//       }
//     },
//     [headers, token, showNotice]
//   );

//   useEffect(() => {
//     if (!token) {
//       setLoading(false);
//       return;
//     }

//     loadRoutingData(false);
//     const interval = window.setInterval(() => loadRoutingData(true), 30000);
//     return () => window.clearInterval(interval);
//   }, [loadRoutingData, token]);

//   const queueOptions = useMemo(() => {
//     const map = new Map();
//     overview.forEach((row) => {
//       if (!row?.queue_id) return;
//       map.set(String(row.queue_id), row.queue_name || `Queue ${row.queue_id}`);
//     });
//     escalationChain.forEach((row) => {
//       if (!row?.queue_id) return;
//       map.set(String(row.queue_id), row.queue_name || `Queue ${row.queue_id}`);
//       if (row.escalation_queue_id) {
//         map.set(String(row.escalation_queue_id), map.get(String(row.escalation_queue_id)) || `Queue ${row.escalation_queue_id}`);
//       }
//     });
//     return Array.from(map.entries()).map(([id, name]) => ({ queue_id: Number(id), queue_name: name }));
//   }, [overview, escalationChain]);

//   const queueNameById = useMemo(() => {
//     const map = new Map();
//     queueOptions.forEach((q) => map.set(String(q.queue_id), q.queue_name));
//     return map;
//   }, [queueOptions]);

//   const filteredCategories = useMemo(() => {
//     const q = search.trim().toLowerCase();
//     if (!q) return categoryMap;
//     return categoryMap.filter((row) => {
//       const hay = [
//         row.category,
//         row.priority,
//         row.queue_name,
//         row.queue_id
//       ]
//         .filter(Boolean)
//         .join(" ")
//         .toLowerCase();
//       return hay.includes(q);
//     });
//   }, [categoryMap, search]);

//   const overviewStats = useMemo(() => {
//     const totalQueues = overview.length;
//     const totalActive = overview.reduce((sum, row) => sum + Number(row.active || 0), 0);
//     const totalEscalated = overview.reduce((sum, row) => sum + Number(row.escalated || 0), 0);
//     const totalBreached = overview.reduce((sum, row) => sum + Number(row.breached || 0), 0);
//     const totalAdmins = overview.reduce((sum, row) => sum + Number(row.admins || 0), 0);

//     const busiest = [...overview].sort((a, b) => Number(b.active || 0) - Number(a.active || 0))[0];
//     const hottest = [...overview].sort((a, b) => Number(b.breached || 0) - Number(a.breached || 0))[0];

//     return {
//       totalQueues,
//       totalActive,
//       totalEscalated,
//       totalBreached,
//       totalAdmins,
//       busiest,
//       hottest
//     };
//   }, [overview]);

//   const simulateRouting = async (e) => {
//     e.preventDefault();
//     if (!simulateForm.category_id) {
//       showNotice("warn", "Category ID is required.");
//       return;
//     }

//     try {
//       setSimulating(true);
//       const res = await axios.post(
//         `${API}/routing/simulate`,
//         {
//           category_id: Number(simulateForm.category_id),
//           priority: simulateForm.priority,
//           escalation_level: Number(simulateForm.escalation_level || 0)
//         },
//         { headers }
//       );

//       setSimulateResult(res.data || null);
//       showNotice("success", "Routing simulation completed.");
//     } catch (error) {
//       console.error("Simulation failed", error);
//       showNotice("error", error?.response?.data?.error || "Simulation failed.");
//     } finally {
//       setSimulating(false);
//     }
//   };

//   const saveCategoryMapping = async (row) => {
//     try {
//       setSavingRowId(row.category_id);
//       await axios.put(
//         `${API}/routing/category-map`,
//         {
//           id: row.id,
//           queue_id: Number(row.queue_id),
//           priority: row.priority
//         },
//         { headers }
//       );

//       showNotice("success", `Routing updated for ${row.category || `Category ${row.category_id}`}.`);
//       await loadRoutingData(true);
//     } catch (error) {
//       console.error("Save mapping failed", error);
//       showNotice("error", error?.response?.data?.error || "Failed to save mapping.");
//     } finally {
//       setSavingRowId(null);
//     }
//   };

//   const runRebalance = async () => {
//     try {
//       setRebalanceLoading(true);
//       const res = await axios.post(`${API}/routing/rebalance`, {}, { headers });
//       showNotice("success", res?.data?.message || "Rebalance started.");
//       await loadRoutingData(true);
//     } catch (error) {
//       console.error("Rebalance failed", error);
//       showNotice("error", error?.response?.data?.error || "Rebalance failed.");
//     } finally {
//       setRebalanceLoading(false);
//     }
//   };

//   const currentTab = TABS.find((t) => t.key === activeTab);

//   if (!token) {
//     return (
//       <div className="rt_page rt_page_access">
//         <div className="rt_access_card">
//           <FaUserShield />
//           <h2>Session expired</h2>
//           <p>Please login again to open Routing.</p>
//         </div>
//       </div>
//     );
//   }

//   if (role !== "SUPER_ADMIN") {
//     return (
//       <div className="rt_page rt_page_access">
//         <div className="rt_access_card">
//           <FaExclamationTriangle />
//           <h2>Access denied</h2>
//           <p>Routing is available for Super Admin only.</p>
//         </div>
//       </div>
//     );
//   }

//   const renderOverview = () => (
//     <div className="rt_overview_grid">
//       <div className="rt_panel rt_panel_large">
//         <div className="rt_panel_head">
//           <div>
//             <span className="rt_kicker">Live routing overview</span>
//             <h3>Queue topology and throughput</h3>
//           </div>
//           <FaSitemap />
//         </div>

//         <div className="rt_queue_cards">
//           {overview.length === 0 ? (
//             <div className="rt_empty">No queue data available.</div>
//           ) : (
//             overview.map((row) => {
//               const active = Number(row.active || 0);
//               const escalated = Number(row.escalated || 0);
//               const breached = Number(row.breached || 0);
//               const admins = Number(row.admins || 0);
//               const pressure = Math.max(active + escalated + breached, 1);
//               const fill = Math.min(100, Math.round((active / pressure) * 100));

//               return (
//                 <div className="rt_queue_card" key={row.queue_id}>
//                   <div className="rt_queue_card_top">
//                     <div>
//                       <h4>{row.queue_name}</h4>
//                       <p>{row.queue_code}</p>
//                     </div>
//                     <span className="rt_queue_id">#{row.queue_id}</span>
//                   </div>

//                   <div className="rt_queue_metrics">
//                     <div>
//                       <strong>{formatNumber(active)}</strong>
//                       <span>Active</span>
//                     </div>
//                     <div>
//                       <strong>{formatNumber(escalated)}</strong>
//                       <span>Escalated</span>
//                     </div>
//                     <div>
//                       <strong>{formatNumber(breached)}</strong>
//                       <span>SLA Risk</span>
//                     </div>
//                     <div>
//                       <strong>{formatNumber(admins)}</strong>
//                       <span>Admins</span>
//                     </div>
//                   </div>

//                   <div className="rt_progress_wrap">
//                     <div className="rt_progress_meta">
//                       <span>Queue pressure</span>
//                       <span>{fill}%</span>
//                     </div>
//                     <div className="rt_progress_bar">
//                       <div className="rt_progress_fill" style={{ width: `${fill}%` }} />
//                     </div>
//                   </div>
//                 </div>
//               );
//             })
//           )}
//         </div>
//       </div>

//       <div className="rt_panel">
//         <div className="rt_panel_head">
//           <div>
//             <span className="rt_kicker">Routing summary</span>
//             <h3>System-wide metrics</h3>
//           </div>
//           <FaRegChartBar />
//         </div>

//         <div className="rt_metric_stack">
//           <div className="rt_metric_item">
//             <FaLayerGroup />
//             <div>
//               <strong>{formatNumber(overviewStats.totalQueues)}</strong>
//               <span>Active queues</span>
//             </div>
//           </div>

//           <div className="rt_metric_item">
//             <FaArrowUp />
//             <div>
//               <strong>{formatNumber(overviewStats.totalActive)}</strong>
//               <span>Active tickets</span>
//             </div>
//           </div>

//           <div className="rt_metric_item">
//             <FaExclamationTriangle />
//             <div>
//               <strong>{formatNumber(overviewStats.totalBreached)}</strong>
//               <span>SLA breached</span>
//             </div>
//           </div>

//           <div className="rt_metric_item">
//             <FaUserShield />
//             <div>
//               <strong>{formatNumber(overviewStats.totalAdmins)}</strong>
//               <span>Queue admins</span>
//             </div>
//           </div>

//           <div className="rt_metric_item">
//             <FaBolt />
//             <div>
//               <strong>{formatNumber(overviewStats.totalEscalated)}</strong>
//               <span>Escalated tickets</span>
//             </div>
//           </div>
//         </div>

//         <div className="rt_info_box">
//           <FaInfoCircle />
//           <div>
//             <strong>Top queue</strong>
//             <p>
//               {overviewStats.busiest
//                 ? `${overviewStats.busiest.queue_name} with ${overviewStats.busiest.active || 0} active tickets`
//                 : "No active queue yet"}
//             </p>
//           </div>
//         </div>

//         <div className="rt_info_box">
//           <FaClock />
//           <div>
//             <strong>Most at risk</strong>
//             <p>
//               {overviewStats.hottest
//                 ? `${overviewStats.hottest.queue_name} with ${overviewStats.hottest.breached || 0} breached tickets`
//                 : "No SLA risk detected"}
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderMap = () => (
//     <div className="rt_panel rt_map_panel">
//       <div className="rt_panel_head">
//         <div>
//           <span className="rt_kicker">Category routing matrix</span>
//           <h3>Category → queue mapping</h3>
//         </div>
//         <FaProjectDiagram />
//       </div>

//       <div className="rt_filter_bar">
//         <div className="rt_search_box">
//           <FaSearch />
//           <input
//             type="text"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Search category, queue, or priority..."
//           />
//         </div>
//         <button className="rt_secondary_btn" onClick={() => setSearch("")}>
//           <FaFilter />
//           Clear
//         </button>
//       </div>

//       <div className="rt_table_wrap">
//         <table className="rt_table">
//           <thead>
//             <tr>
//               <th>Category</th>
//               <th>Priority</th>
//               <th>Queue</th>
//               <th>Default</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredCategories.length === 0 ? (
//               <tr>
//                 <td colSpan={5}>
//                   <div className="rt_empty_table">No routing mappings found.</div>
//                 </td>
//               </tr>
//             ) : (
//               filteredCategories.map((row) => {
//                 const editableQueueId = String(row.queue_id || "");
//                 const editablePriority = row.priority || "normal";

//                 return (
//                   <tr key={`${row.category_id}-${row.queue_id}-${row.priority}`}>
//                     <td>
//                       <div className="rt_table_main">
//                         <strong>{row.category}</strong>
//                         <span>Category ID #{row.category_id}</span>
//                       </div>
//                     </td>

//                     <td>
//                       <select
//                         className="rt_select"
//                         value={editablePriority}
//                         onChange={(e) => {
//                           setCategoryMap((prev) =>
//                             prev.map((item) =>
//                               item.category_id === row.category_id &&
//                                 item.queue_id === row.queue_id &&
//                                 item.priority === row.priority
//                                 ? { ...item, priority: e.target.value }
//                                 : item
//                             )
//                           );
//                         }}
//                       >
//                         <option value="low">Low</option>
//                         <option value="normal">Normal</option>
//                         <option value="high">High</option>
//                       </select>
//                     </td>

//                     <td>
//                       <select
//                         className="rt_select"
//                         value={editableQueueId}
//                         onChange={(e) => {
//                           setCategoryMap((prev) =>
//                             prev.map((item) =>
//                               item.category_id === row.category_id &&
//                                 item.queue_id === row.queue_id &&
//                                 item.priority === row.priority
//                                 ? { ...item, queue_id: Number(e.target.value) }
//                                 : item
//                             )
//                           );
//                         }}
//                       >
//                         {queueOptions.map((q) => (
//                           <option key={q.queue_id} value={q.queue_id}>
//                             {q.queue_name}
//                           </option>
//                         ))}
//                       </select>
//                     </td>

//                     <td>
//                       {row.is_default ? (
//                         <span className="rt_badge rt_badge_success">Default</span>
//                       ) : (
//                         <span className="rt_badge rt_badge_muted">Secondary</span>
//                       )}
//                     </td>

//                     <td>
//                       <button
//                         className="rt_primary_btn"
//                         onClick={() => saveCategoryMapping({
//                           ...row,
//                           queue_id: editableQueueId,
//                           priority: editablePriority
//                         })}
//                         disabled={savingRowId === row.category_id}
//                       >
//                         {savingRowId === row.category_id ? (
//                           <>
//                             <FaSpinner className="rt_spin" />
//                             Saving
//                           </>
//                         ) : (
//                           <>
//                             <FaSave />
//                             Save
//                           </>
//                         )}
//                       </button>
//                     </td>
//                   </tr>
//                 );
//               })
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );

//   const renderSimulator = () => (
//     <div className="rt_simulator_grid">
//       <div className="rt_panel">
//         <div className="rt_panel_head">
//           <div>
//             <span className="rt_kicker">Routing simulator</span>
//             <h3>Predict queue and admin allocation</h3>
//           </div>
//           <FaBolt />
//         </div>

//         <form className="rt_sim_form" onSubmit={simulateRouting}>
//           <label>
//             <span>Category ID</span>
//             <input
//               type="number"
//               value={simulateForm.category_id}
//               onChange={(e) =>
//                 setSimulateForm((prev) => ({
//                   ...prev,
//                   category_id: e.target.value
//                 }))
//               }
//               placeholder="Enter category ID"
//             />
//           </label>

//           <label>
//             <span>Priority</span>
//             <select
//               value={simulateForm.priority}
//               onChange={(e) =>
//                 setSimulateForm((prev) => ({
//                   ...prev,
//                   priority: e.target.value
//                 }))
//               }
//             >
//               <option value="low">Low</option>
//               <option value="normal">Normal</option>
//               <option value="high">High</option>
//             </select>
//           </label>

//           <label>
//             <span>Escalation level</span>
//             <input
//               type="number"
//               min="0"
//               max="5"
//               value={simulateForm.escalation_level}
//               onChange={(e) =>
//                 setSimulateForm((prev) => ({
//                   ...prev,
//                   escalation_level: e.target.value
//                 }))
//               }
//             />
//           </label>

//           <button className="rt_primary_btn rt_sim_btn" type="submit" disabled={simulating}>
//             {simulating ? (
//               <>
//                 <FaSpinner className="rt_spin" />
//                 Simulating
//               </>
//             ) : (
//               <>
//                 <FaBolt />
//                 Simulate routing
//               </>
//             )}
//           </button>
//         </form>
//       </div>

//       <div className="rt_panel">
//         <div className="rt_panel_head">
//           <div>
//             <span className="rt_kicker">Simulation result</span>
//             <h3>Resolved routing output</h3>
//           </div>
//           <FaInfoCircle />
//         </div>

//         {simulateResult ? (
//           <div className="rt_result_grid">
//             <div className="rt_result_card">
//               <span>Resolved Queue</span>

//               <strong>
//                 {simulateResult?.resolved_queue?.queue_name || "—"}
//               </strong>

//               <small>
//                 {simulateResult?.resolved_queue?.queue_code || ""}
//               </small>

//               <small>
//                 Capacity :
//                 {" "}
//                 {simulateResult?.resolved_queue?.max_capacity || 0}
//               </small>
//             </div>

//             <div className="rt_result_card">
//               <span>Assigned Admin</span>

//               <strong>
//                 {simulateResult?.assigned_admin?.name || "No Admin"}
//               </strong>

//               <small>
//                 {simulateResult?.assigned_admin?.email || ""}
//               </small>

//               <small>
//                 Workload :
//                 {" "}
//                 {simulateResult?.assigned_admin?.workload || 0}
//               </small>
//             </div>
//           </div>
//         ) : (
//           <div className="rt_empty_result">
//             Run a simulation to preview queue resolution and admin selection.
//           </div>
//         )}
//       </div>
//     </div>
//   );

//   const renderHealth = () => (
//     <div className="rt_panel">
//       <div className="rt_panel_head">
//         <div>
//           <span className="rt_kicker">Live queue health</span>
//           <h3>Current load and response pressure</h3>
//         </div>
//         <FaClock />
//       </div>

//       <div className="rt_table_wrap">
//         <table className="rt_table">
//           <thead>
//             <tr>
//               <th>Queue</th>
//               <th>Tickets</th>
//               <th>Avg Hours</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {liveHealth.length === 0 ? (
//               <tr>
//                 <td colSpan={4}>
//                   <div className="rt_empty_table">No queue health data available.</div>
//                 </td>
//               </tr>
//             ) : (
//               liveHealth.map((row) => {
//                 const ticketsCount = Number(row.tickets || 0);
//                 const avgHours = Number(row.avg_hours || 0);
//                 const status =
//                   ticketsCount >= 50 || avgHours >= 12
//                     ? "Critical"
//                     : ticketsCount >= 25 || avgHours >= 6
//                       ? "Warning"
//                       : "Healthy";

//                 return (
//                   <tr key={row.queue_name}>
//                     <td>
//                       <div className="rt_table_main">
//                         <strong>{row.queue_name}</strong>
//                         <span>{status} queue pressure</span>
//                       </div>
//                     </td>
//                     <td>{formatNumber(ticketsCount)}</td>
//                     <td>{formatHours(avgHours)}</td>
//                     <td>
//                       <span
//                         className={
//                           status === "Critical"
//                             ? "rt_badge rt_badge_danger"
//                             : status === "Warning"
//                               ? "rt_badge rt_badge_warn"
//                               : "rt_badge rt_badge_success"
//                         }
//                       >
//                         {status}
//                       </span>
//                     </td>
//                   </tr>
//                 );
//               })
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );

//   const renderChain = () => (
//     <div className="rt_chain_wrap">
//       <div className="rt_panel rt_chain_panel">
//         <div className="rt_panel_head">
//           <div>
//             <span className="rt_kicker">Escalation chain</span>
//             <h3>Queue → queue transfer map</h3>
//           </div>
//           <FaSitemap />
//         </div>

//         <div className="rt_chain_list">
//           {escalationChain.length === 0 ? (
//             <div className="rt_empty">No escalation chain found.</div>
//           ) : (
//             escalationChain.map((row) => (
//               <div className="rt_chain_item" key={row.queue_id}>
//                 <div className="rt_chain_left">
//                   <div className="rt_chain_node">
//                     {row.queue_name || `Queue ${row.queue_id}`}
//                   </div>
//                   <FaArrowRight />
//                   <div className="rt_chain_target">
//                     {row.escalation_queue_id
//                       ? queueNameById.get(String(row.escalation_queue_id)) ||
//                       `Queue ${row.escalation_queue_id}`
//                       : "No escalation queue"}
//                   </div>
//                 </div>

//                 <div className="rt_chain_meta">
//                   <span>Queue ID #{row.queue_id}</span>
//                   <span>Escalation target #{row.escalation_queue_id || "—"}</span>
//                 </div>
//               </div>
//             ))
//           )}
//         </div>
//       </div>

//       <div className="rt_panel">
//         <div className="rt_panel_head">
//           <div>
//             <span className="rt_kicker">Routing rules</span>
//             <h3>Operational behavior</h3>
//           </div>
//           <FaCogs />
//         </div>

//         <div className="rt_rule_list">
//           <div className="rt_rule_card">
//             <FaProjectDiagram />
//             <div>
//               <strong>Category mapping</strong>
//               <p>Every ticket resolves to a queue before any admin assignment.</p>
//             </div>
//           </div>

//           <div className="rt_rule_card">
//             <FaLayerGroup />
//             <div>
//               <strong>Workload aware assignment</strong>
//               <p>Admins are selected based on queue membership and capacity.</p>
//             </div>
//           </div>

//           <div className="rt_rule_card">
//             <FaRetweet />
//             <div>
//               <strong>Escalation transfer</strong>
//               <p>Queue moves forward through the configured escalation chain.</p>
//             </div>
//           </div>

//           <div className="rt_rule_card">
//             <FaExclamationTriangle />
//             <div>
//               <strong>Fallback safety</strong>
//               <p>Routing simulation helps catch invalid mappings before deployment.</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   const renderActions = () => (
//     <div className="rt_action_grid">
//       <div className="rt_panel">
//         <div className="rt_panel_head">
//           <div>
//             <span className="rt_kicker">Maintenance</span>
//             <h3>Manual system control</h3>
//           </div>
//           <FaCogs />
//         </div>

//         <div className="rt_action_card">
//           <div>
//             <strong>Rebalance queues</strong>
//             <p>Ask the system to rebalance routing based on the current queue state.</p>
//           </div>
//           <button
//             className="rt_primary_btn"
//             onClick={runRebalance}
//             disabled={rebalanceLoading}
//           >
//             {rebalanceLoading ? (
//               <>
//                 <FaSpinner className="rt_spin" />
//                 Running
//               </>
//             ) : (
//               <>
//                 <FaRetweet />
//                 Rebalance
//               </>
//             )}
//           </button>
//         </div>

//         <div className="rt_action_card">
//           <div>
//             <strong>Refresh live routing data</strong>
//             <p>Pull the latest queue topology, mapping, and health values.</p>
//           </div>
//           <button className="rt_secondary_btn" onClick={() => loadRoutingData(true)}>
//             <FaSyncAlt />
//             Refresh now
//           </button>
//         </div>
//       </div>

//       <div className="rt_panel">
//         <div className="rt_panel_head">
//           <div>
//             <span className="rt_kicker">Quick snapshot</span>
//             <h3>Current routing status</h3>
//           </div>
//           <FaCheckCircle />
//         </div>

//         <div className="rt_snapshot_list">
//           <div className="rt_snapshot_item">
//             <span>Total queues</span>
//             <strong>{overviewStats.totalQueues}</strong>
//           </div>
//           <div className="rt_snapshot_item">
//             <span>Active tickets</span>
//             <strong>{overviewStats.totalActive}</strong>
//           </div>
//           <div className="rt_snapshot_item">
//             <span>Escalated tickets</span>
//             <strong>{overviewStats.totalEscalated}</strong>
//           </div>
//           <div className="rt_snapshot_item">
//             <span>SLA breached</span>
//             <strong>{overviewStats.totalBreached}</strong>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   if (loading) {
//     return (
//  <div className="support-loader">
//   <div className="support-loader-card">
//     <div className="support-loader-ring" />
//           <h2>Loading Routing</h2>
//           <p>Preparing queue topology and routing controls...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="support-page">
//       {notice ? (
//         <div
//           className={`rt_notice ${notice.type === "success"
//             ? "rt_notice_success"
//             : notice.type === "warn"
//               ? "rt_notice_warn"
//               : "rt_notice_error"
//             }`}
//         >
//           {notice.text}
//         </div>
//       ) : null}

//       <div className="support-header">
//         <div>
//           <div className="support-live-tag">

//             <span className="support-live-dot"></span>
//             <span />
//             ROUTING CONTROL CENTER
//           </div>
//           <h1>Routing</h1>
//           <p>
//             Manage queue topology, category mapping, escalation flow, and live routing health.
//           </p>
//         </div>

//         <div className="support-header-actions">
//           <button className="support-refresh-btn" onClick={() => loadRoutingData(true)} disabled={refreshing}>
//             <FaSyncAlt />
//             {/* {refreshing ? "Refreshing" : "Refresh"} */}
//           </button>
//           {/* <div className="rt_header_meta">
//             <FaUserShield />
//             Super Admin
//           </div> */}
//         </div>
//       </div>

//       <div className="support-tabs">
//         {TABS.map((tab) => (
//           <button
//             key={tab.key}
//             className={`support-tab ${activeTab === tab.key ? "active" : ""}`}
//             onClick={() => setActiveTab(tab.key)}
//           >
//             {tab.icon}
//             {tab.label}
//           </button>
//         ))}
//       </div>

//       <div className="rt_section_label">
//         <span>{currentTab?.label || "Routing"}</span>
//       </div>

//       {activeTab === "overview" && renderOverview()}
//       {activeTab === "map" && renderMap()}
//       {activeTab === "simulate" && renderSimulator()}
//       {activeTab === "health" && renderHealth()}
//       {activeTab === "chain" && renderChain()}
//       {activeTab === "actions" && renderActions()}
//     </div>
//   );
// }


import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import {
  FaSpinner,
  FaSyncAlt,
  FaSitemap,
  FaProjectDiagram,
  FaSearch,
  FaBolt,
  FaClock,
  FaUserShield,
  FaExclamationTriangle,
  FaLayerGroup,
  FaSave,
  FaRetweet,
  FaInfoCircle,
  FaCheckCircle,
  FaCogs,
  FaRegChartBar,
  FaFilter,
  FaArrowRight,
  FaArrowUp
} from "react-icons/fa";

// import "./Routing.css"
import "./Support.css";

const API = "https://api.mahal.qa/api/v1/admin/support";

const TABS = [
  { key: "overview", label: "Overview", icon: <FaRegChartBar /> },
  { key: "map", label: "Category Routing", icon: <FaProjectDiagram /> },
  { key: "simulate", label: "Simulator", icon: <FaBolt /> },
  { key: "health", label: "Queue Health", icon: <FaLayerGroup /> },
  { key: "chain", label: "Escalation Chain", icon: <FaSitemap /> },
  { key: "actions", label: "Actions", icon: <FaCogs /> }
];

function formatNumber(value) {
  const n = Number(value || 0);
  return new Intl.NumberFormat("en-IN").format(n);
}

function formatHours(value) {
  const n = Number(value || 0);
  if (!Number.isFinite(n)) return "0h";
  return `${n.toFixed(1)}h`;
}

function getRole() {
  return (localStorage.getItem("admin_role") || "")
    .trim()
    .replace(/\s+/g, "_")
    .toUpperCase();
}

function normalizePriority(priority) {
  const value = String(priority || "normal").toLowerCase();
  if (value === "high") return "high";
  if (value === "low") return "low";
  return "normal";
}

function getStatusLabel(status) {
  const value = String(status || "").toLowerCase();
  if (!value) return "open";
  return value;
}

export default function Routing() {
  const token = localStorage.getItem("admin_token");
  const role = getRole();

  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");

  const [notice, setNotice] = useState(null);

  const [overview, setOverview] = useState([]);
  const [categoryMap, setCategoryMap] = useState([]);
  const [liveHealth, setLiveHealth] = useState([]);
  const [escalationChain, setEscalationChain] = useState([]);

  const [search, setSearch] = useState("");
  const [savingRowId, setSavingRowId] = useState(null);

  const [simulateForm, setSimulateForm] = useState({
    category_id: "",
    priority: "normal",
    escalation_level: 0
  });

  const [simulateResult, setSimulateResult] = useState(null);
  const [simulating, setSimulating] = useState(false);
  const [rebalanceLoading, setRebalanceLoading] = useState(false);

  const noticeTimerRef = useRef(null);

  const headers = useMemo(
    () => ({
      Authorization: `Bearer ${token}`
    }),
    [token]
  );

  const showNotice = useCallback((type, text) => {
    setNotice({ type, text });

    if (noticeTimerRef.current) {
      clearTimeout(noticeTimerRef.current);
    }

    noticeTimerRef.current = setTimeout(() => {
      setNotice(null);
    }, 350000);
  }, []);

  const loadRoutingData = useCallback(
    async (silent = false) => {
      if (!token) return;

      try {
        if (silent) setRefreshing(true);
        else setLoading(true);

        const requests = [
          axios.get(`${API}/routing/overview`, { headers }),
          axios.get(`${API}/routing/category-map`, { headers }),
          axios.get(`${API}/routing/live-health`, { headers }),
          axios.get(`${API}/routing/escalation-chain`, { headers })
        ];

        const [overviewRes, mapRes, healthRes, chainRes] = await Promise.allSettled(requests);

        if (overviewRes.status === "fulfilled") {
          setOverview(Array.isArray(overviewRes.value.data) ? overviewRes.value.data : []);
        } else {
          setOverview([]);
        }

        if (mapRes.status === "fulfilled") {
          setCategoryMap(Array.isArray(mapRes.value.data) ? mapRes.value.data : []);
        } else {
          setCategoryMap([]);
        }

        if (healthRes.status === "fulfilled") {
          setLiveHealth(Array.isArray(healthRes.value.data) ? healthRes.value.data : []);
        } else {
          setLiveHealth([]);
        }

        if (chainRes.status === "fulfilled") {
          setEscalationChain(Array.isArray(chainRes.value.data) ? chainRes.value.data : []);
        } else {
          setEscalationChain([]);
        }

        if (
          overviewRes.status === "rejected" ||
          mapRes.status === "rejected" ||
          healthRes.status === "rejected" ||
          chainRes.status === "rejected"
        ) {
          showNotice("warn", "Some routing data could not be loaded.");
        }
      } catch (error) {
        console.error("Routing load failed", error);
        showNotice("error", "Failed to load routing data.");
      } finally {
        setLoading(false);
        setRefreshing(false);
      }
    },
    [headers, token, showNotice]
  );

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }

    loadRoutingData(false);

    const interval = window.setInterval(() => {
      loadRoutingData(true);
    }, 30000);

    return () => {
      window.clearInterval(interval);
      if (noticeTimerRef.current) {
        clearTimeout(noticeTimerRef.current);
      }
    };
  }, [loadRoutingData, token]);

  const queueOptions = useMemo(() => {
    const map = new Map();

    overview.forEach((row) => {
      if (!row?.queue_id) return;
      map.set(String(row.queue_id), row.queue_name || `Queue ${row.queue_id}`);
    });

    escalationChain.forEach((row) => {
      if (!row?.queue_id) return;
      map.set(String(row.queue_id), row.queue_name || `Queue ${row.queue_id}`);
      if (row.escalation_queue_id) {
        map.set(
          String(row.escalation_queue_id),
          map.get(String(row.escalation_queue_id)) || `Queue ${row.escalation_queue_id}`
        );
      }
    });

    return Array.from(map.entries()).map(([id, name]) => ({
      queue_id: Number(id),
      queue_name: name
    }));
  }, [overview, escalationChain]);

  const queueNameById = useMemo(() => {
    const map = new Map();
    queueOptions.forEach((q) => map.set(String(q.queue_id), q.queue_name));
    return map;
  }, [queueOptions]);

  const filteredCategories = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return categoryMap;

    return categoryMap.filter((row) => {
      const hay = [
        row.category,
        row.priority,
        row.queue_name,
        row.queue_id
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return hay.includes(q);
    });
  }, [categoryMap, search]);

  const overviewStats = useMemo(() => {
    const totalQueues = overview.length;
    const totalActive = overview.reduce((sum, row) => sum + Number(row.active || 0), 0);
    const totalEscalated = overview.reduce((sum, row) => sum + Number(row.escalated || 0), 0);
    const totalBreached = overview.reduce((sum, row) => sum + Number(row.breached || 0), 0);
    const totalAdmins = overview.reduce((sum, row) => sum + Number(row.admins || 0), 0);

    const busiest = [...overview].sort((a, b) => Number(b.active || 0) - Number(a.active || 0))[0];
    const hottest = [...overview].sort((a, b) => Number(b.breached || 0) - Number(a.breached || 0))[0];

    return {
      totalQueues,
      totalActive,
      totalEscalated,
      totalBreached,
      totalAdmins,
      busiest,
      hottest
    };
  }, [overview]);

  const simulateRouting = async (e) => {
    e.preventDefault();

    if (!simulateForm.category_id) {
      showNotice("warn", "Category ID is required.");
      return;
    }

    try {
      setSimulating(true);

      const res = await axios.post(
        `${API}/routing/simulate`,
        {
          category_id: Number(simulateForm.category_id),
          priority: simulateForm.priority,
          escalation_level: Number(simulateForm.escalation_level || 0)
        },
        { headers }
      );

      setSimulateResult(res.data || null);
      showNotice("success", "Routing simulation completed.");
    } catch (error) {
      console.error("Simulation failed", error);
      showNotice("error", error?.response?.data?.error || "Simulation failed.");
    } finally {
      setSimulating(false);
    }
  };

  const saveCategoryMapping = async (row) => {
    try {
      setSavingRowId(row.category_id);

      await axios.put(
        `${API}/routing/category-map`,
        {
          id: row.id,
          queue_id: Number(row.queue_id),
          priority: row.priority
        },
        { headers }
      );

      showNotice("success", `Routing updated for ${row.category || `Category ${row.category_id}`}.`);
      await loadRoutingData(true);
    } catch (error) {
      console.error("Save mapping failed", error);
      showNotice("error", error?.response?.data?.error || "Failed to save mapping.");
    } finally {
      setSavingRowId(null);
    }
  };

  const runRebalance = async () => {
    try {
      setRebalanceLoading(true);
      const res = await axios.post(`${API}/routing/rebalance`, {}, { headers });
      showNotice("success", res?.data?.message || "Rebalance started.");
      await loadRoutingData(true);
    } catch (error) {
      console.error("Rebalance failed", error);
      showNotice("error", error?.response?.data?.error || "Rebalance failed.");
    } finally {
      setRebalanceLoading(false);
    }
  };

  const currentTab = TABS.find((t) => t.key === activeTab);

  if (!token) {
    return (
      <div className="support-loader">
        <div className="support-loader-card">
          <FaSpinner className="support-loading" />
          <h2>Session expired</h2>
          <p>Please login again to open Routing.</p>
        </div>
      </div>
    );
  }

  if (role !== "SUPER_ADMIN") {
    return (
      <div className="support-loader">
        <div className="support-loader-card">
          <FaExclamationTriangle />
          <h2>Access denied</h2>
          <p>Routing is available for Super Admin only.</p>
        </div>
      </div>
    );
  }

  const renderOverview = () => (
    <div className="support-routing-overview-grid">
      <div className="support-panel support-panel--accent">
        <div className="support-panel-header">
          <div className="support-panel-title">
            <span>Live routing overview</span>
            <h3>Queue topology and throughput</h3>
          </div>
          <div className="support-panel-icon">
            <FaSitemap />
          </div>
        </div>

        <div className="support-routing-queue-grid">
          {overview.length === 0 ? (
            <div className="support-empty-state">No queue data available.</div>
          ) : (
            overview.map((row) => {
              const active = Number(row.active || 0);
              const escalated = Number(row.escalated || 0);
              const breached = Number(row.breached || 0);
              const admins = Number(row.admins || 0);
              const pressure = Math.max(active + escalated + breached, 1);
              const fill = Math.min(100, Math.round((active / pressure) * 100));

              return (
                <div className="support-routing-queue-card" key={row.queue_id}>
                  <div className="support-routing-queue-top">
                    <div>
                      <h4>{row.queue_name}</h4>
                      <p>{row.queue_code}</p>
                    </div>
                    <span className="support-badge is-sla-safe">#{row.queue_id}</span>
                  </div>

                  <div className="support-routing-queue-metrics">
                    <div>
                      <strong>{formatNumber(active)}</strong>
                      <span>Active</span>
                    </div>
                    <div>
                      <strong>{formatNumber(escalated)}</strong>
                      <span>Escalated</span>
                    </div>
                    <div>
                      <strong>{formatNumber(breached)}</strong>
                      <span>SLA Risk</span>
                    </div>
                    <div>
                      <strong>{formatNumber(admins)}</strong>
                      <span>Admins</span>
                    </div>
                  </div>

                  <div className="support-routing-progress-wrap">
                    <div className="support-routing-progress-meta">
                      <span>Queue pressure</span>
                      <span>{fill}%</span>
                    </div>
                    <div className="support-routing-progress-bar">
                      <div
                        className="support-routing-progress-fill"
                        style={{ width: `${fill}%` }}
                      />
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      <div className="support-panel">
        <div className="support-panel-header">
          <div className="support-panel-title">
            <span>Routing summary</span>
            <h3>System-wide metrics</h3>
          </div>
          <div className="support-panel-icon">
            <FaRegChartBar />
          </div>
        </div>

        <div className="support-routing-metric-stack">
          <div className="support-kpi">
            <FaLayerGroup />
            <div>
              <strong>{formatNumber(overviewStats.totalQueues)}</strong>
              <span>Active queues</span>
            </div>
          </div>

          <div className="support-kpi">
            <FaArrowUp />
            <div>
              <strong>{formatNumber(overviewStats.totalActive)}</strong>
              <span>Active tickets</span>
            </div>
          </div>

          <div className="support-kpi">
            <FaExclamationTriangle />
            <div>
              <strong>{formatNumber(overviewStats.totalBreached)}</strong>
              <span>SLA breached</span>
            </div>
          </div>

          <div className="support-kpi">
            <FaUserShield />
            <div>
              <strong>{formatNumber(overviewStats.totalAdmins)}</strong>
              <span>Queue admins</span>
            </div>
          </div>

          <div className="support-kpi">
            <FaBolt />
            <div>
              <strong>{formatNumber(overviewStats.totalEscalated)}</strong>
              <span>Escalated tickets</span>
            </div>
          </div>
        </div>

        <div className="support-routing-info-box">
          <FaInfoCircle />
          <div>
            <strong>Top queue</strong>
            <p>
              {overviewStats.busiest
                ? `${overviewStats.busiest.queue_name} with ${overviewStats.busiest.active || 0} active tickets`
                : "No active queue yet"}
            </p>
          </div>
        </div>

        <div className="support-routing-info-box">
          <FaClock />
          <div>
            <strong>Most at risk</strong>
            <p>
              {overviewStats.hottest
                ? `${overviewStats.hottest.queue_name} with ${overviewStats.hottest.breached || 0} breached tickets`
                : "No SLA risk detected"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderMap = () => (
    <div className="support-panel">
      <div className="support-panel-header">
        <div className="support-panel-title">
          <span>Category routing matrix</span>
          <h3>Category → queue mapping</h3>
        </div>
        <div className="support-panel-icon">
          <FaProjectDiagram />
        </div>
      </div>

      <div className="support-filters">
        
          {/* <FaSearch /> */}
          <input className="support-search"
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search category, queue, or priority..."
          />
        

        <button className="support-secondary-btn" onClick={() => setSearch("")}>
          <FaFilter />
          Clear
        </button>
      </div>

      <div className="support-table-wrap">
        <table className="support-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Priority</th>
              <th>Queue</th>
              <th>Default</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredCategories.length === 0 ? (
              <tr>
                <td colSpan={5}>
                  <div className="support-empty-state">No routing mappings found.</div>
                </td>
              </tr>
            ) : (
              filteredCategories.map((row) => {
                const editableQueueId = String(row.queue_id || "");
                const editablePriority = row.priority || "normal";

                return (
                  <tr key={`${row.category_id}-${row.queue_id}-${row.priority}`}>
                    <td>
                      <div className="support-table-title">
                        <strong>{row.category}</strong>
                        <span>Category ID #{row.category_id}</span>
                      </div>
                    </td>

                    <td>
                      <select
                        className="support-select"
                        value={editablePriority}
                        onChange={(e) => {
                          setCategoryMap((prev) =>
                            prev.map((item) =>
                              item.category_id === row.category_id &&
                                item.queue_id === row.queue_id &&
                                item.priority === row.priority
                                ? { ...item, priority: e.target.value }
                                : item
                            )
                          );
                        }}
                      >
                        <option value="low">Low</option>
                        <option value="normal">Normal</option>
                        <option value="high">High</option>
                      </select>
                    </td>

                    <td>
                      <select
                        className="support-select"
                        value={editableQueueId}
                        onChange={(e) => {
                          setCategoryMap((prev) =>
                            prev.map((item) =>
                              item.category_id === row.category_id &&
                                item.queue_id === row.queue_id &&
                                item.priority === row.priority
                                ? { ...item, queue_id: Number(e.target.value) }
                                : item
                            )
                          );
                        }}
                      >
                        {queueOptions.map((q) => (
                          <option key={q.queue_id} value={q.queue_id}>
                            {q.queue_name}
                          </option>
                        ))}
                      </select>
                    </td>

                    <td>
                      {row.is_default ? (
                        <span className="support-badge is-sla-safe">Default</span>
                      ) : (
                        <span className="support-badge is-normal">Secondary</span>
                      )}
                    </td>

                    <td>
                      <button
                        className="support-primary-btn"
                        onClick={() =>
                          saveCategoryMapping({
                            ...row,
                            queue_id: editableQueueId,
                            priority: editablePriority
                          })
                        }
                        disabled={savingRowId === row.category_id}
                      >
                        {savingRowId === row.category_id ? (
                          <>
                            <FaSpinner className="support-loading" />
                            Saving
                          </>
                        ) : (
                          <>
                            <FaSave />
                            Save
                          </>
                        )}
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderSimulator = () => (
    <div className="support-routing-sim-grid">
      <div className="support-panel">
        <div className="support-panel-header">
          <div className="support-panel-title">
            <span>Routing simulator</span>
            <h3>Predict queue and admin allocation</h3>
          </div>
          <div className="support-panel-icon">
            <FaBolt />
          </div>
        </div>

        <form className="support-routing-sim-form" onSubmit={simulateRouting}>
          <label>
            <span>Category ID</span>
            <input
              className="support-input"
              type="number"
              value={simulateForm.category_id}
              onChange={(e) =>
                setSimulateForm((prev) => ({
                  ...prev,
                  category_id: e.target.value
                }))
              }
              placeholder="Enter category ID"
            />
          </label>

          <label>
            <span>Priority</span>
            <select
              className="support-select"
              value={simulateForm.priority}
              onChange={(e) =>
                setSimulateForm((prev) => ({
                  ...prev,
                  priority: e.target.value
                }))
              }
            >
              <option value="low">Low</option>
              <option value="normal">Normal</option>
              <option value="high">High</option>
            </select>
          </label>

          <label>
            <span>Escalation level</span>
            <input
              className="support-input"
              type="number"
              min="0"
              max="5"
              value={simulateForm.escalation_level}
              onChange={(e) =>
                setSimulateForm((prev) => ({
                  ...prev,
                  escalation_level: e.target.value
                }))
              }
            />
          </label>

          {/* <button
            className="support-table-btn"
            type="submit"
            disabled={simulating}
          >
            {simulating ? (
              <>
                <FaSpinner className="support-loading" />
                Simulating
              </>
            ) : (
              <>
                <FaBolt />
                Simulate routing
              </>
            )}
          </button> */}
        </form>
        <button
            className="support-table-btn"
            type="submit"
            disabled={simulating}
          >
            {simulating ? (
              <>
                <FaSpinner className="support-loading" />
                Simulating
              </>
            ) : (
              <>
                <FaBolt />
                Simulate routing
              </>
            )}
          </button>
      </div>

      <div className="support-panel">
        <div className="support-panel-header">
          <div className="support-panel-title">
            <span>Simulation result</span>
            <h3>Resolved routing output</h3>
          </div>
          <div className="support-panel-icon">
            <FaInfoCircle />
          </div>
        </div>

        {simulateResult ? (
          <div className="support-routing-result-grid">
            <div className="support-routing-result-card">
              <span>Resolved Queue</span>
              <strong>{simulateResult?.resolved_queue?.queue_name || "—"}</strong>
              <small>{simulateResult?.resolved_queue?.queue_code || ""}</small>
              <small>
                Capacity: {simulateResult?.resolved_queue?.max_capacity || 0}
              </small>
            </div>

            <div className="support-routing-result-card">
              <span>Assigned Admin</span>
              <strong>{simulateResult?.assigned_admin?.name || "No Admin"}</strong>
              <small>{simulateResult?.assigned_admin?.email || ""}</small>
              <small>
                Workload: {simulateResult?.assigned_admin?.workload || 0}
              </small>
            </div>
          </div>
        ) : (
          <div className="support-empty-state">
            Run a simulation to preview queue resolution and admin selection.
          </div>
        )}
      </div>
    </div>
  );

  const renderHealth = () => (
    <div className="support-panel">
      <div className="support-panel-header">
        <div className="support-panel-title">
          <span>Live queue health</span>
          <h3>Current load and response pressure</h3>
        </div>
        <div className="support-panel-icon">
          <FaClock />
        </div>
      </div>

      <div className="support-table-wrap">
        <table className="support-table">
          <thead>
            <tr>
              <th>Queue</th>
              <th>Tickets</th>
              <th>Avg Hours</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {liveHealth.length === 0 ? (
              <tr>
                <td colSpan={4}>
                  <div className="support-empty-state">No queue health data available.</div>
                </td>
              </tr>
            ) : (
              liveHealth.map((row) => {
                const ticketsCount = Number(row.tickets || 0);
                const avgHours = Number(row.avg_hours || 0);
                const status =
                  ticketsCount >= 50 || avgHours >= 12
                    ? "Critical"
                    : ticketsCount >= 25 || avgHours >= 6
                      ? "Warning"
                      : "Healthy";

                return (
                  <tr key={row.queue_name}>
                    <td>
                      <div className="support-table-title">
                        <strong>{row.queue_name}</strong>
                        <span>{status} queue pressure</span>
                      </div>
                    </td>
                    <td>{formatNumber(ticketsCount)}</td>
                    <td>{formatHours(avgHours)}</td>
                    <td>
                      <span
                        className={
                          status === "Critical"
                            ? "support-badge is-critical"
                            : status === "Warning"
                              ? "support-badge is-normal"
                              : "support-badge is-sla-safe"
                        }
                      >
                        {status}
                      </span>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  const renderChain = () => (
    <div className="support-routing-chain-wrap">
      <div className="support-panel">
        <div className="support-panel-header">
          <div className="support-panel-title">
            <span>Escalation chain</span>
            <h3>Queue → queue transfer map</h3>
          </div>
          <div className="support-panel-icon">
            <FaSitemap />
          </div>
        </div>

        <div className="support-routing-chain-list">
          {escalationChain.length === 0 ? (
            <div className="support-empty-state">No escalation chain found.</div>
          ) : (
            escalationChain.map((row) => (
              <div className="support-routing-chain-item" key={row.queue_id}>
                <div className="support-routing-chain-left">
                  <div className="support-routing-chain-node">
                    {row.queue_name || `Queue ${row.queue_id}`}
                  </div>
                  <FaArrowRight />
                  <div className="support-routing-chain-target">
                    {row.escalation_queue_id
                      ? queueNameById.get(String(row.escalation_queue_id)) ||
                      `Queue ${row.escalation_queue_id}`
                      : "No escalation queue"}
                  </div>
                </div>

                <div className="support-routing-chain-meta">
                  <span>Queue ID #{row.queue_id}</span>
                  <span>Escalation target #{row.escalation_queue_id || "—"}</span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <div className="support-panel">
        <div className="support-panel-header">
          <div className="support-panel-title">
            <span>Routing rules</span>
            <h3>Operational behavior</h3>
          </div>
          <div className="support-panel-icon">
            <FaCogs />
          </div>
        </div>

        <div className="support-rule-grid">
          <div className="support-rule-card">
            <div className="support-rule-top">
              <div className="support-rule-icon">
                <FaProjectDiagram />
              </div>
              <div className="support-rule-status active">Active</div>
            </div>
            <h3>Category mapping</h3>
            <p>Every ticket resolves to a queue before any admin assignment.</p>
          </div>

          <div className="support-rule-card">
            <div className="support-rule-top">
              <div className="support-rule-icon">
                <FaLayerGroup />
              </div>
              <div className="support-rule-status active">Active</div>
            </div>
            <h3>Workload aware assignment</h3>
            <p>Admins are selected based on queue membership and capacity.</p>
          </div>

          <div className="support-rule-card">
            <div className="support-rule-top">
              <div className="support-rule-icon">
                <FaRetweet />
              </div>
              <div className="support-rule-status active">Active</div>
            </div>
            <h3>Escalation transfer</h3>
            <p>Queue moves forward through the configured escalation chain.</p>
          </div>

          <div className="support-rule-card critical">
            <div className="support-rule-top">
              <div className="support-rule-icon">
                <FaExclamationTriangle />
              </div>
              <div className="support-rule-status paused">Review</div>
            </div>
            <h3>Fallback safety</h3>
            <p>Routing simulation helps catch invalid mappings before deployment.</p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderActions = () => (
    <div className="support-routing-action-grid">
      <div className="support-panel">
        <div className="support-panel-header">
          <div className="support-panel-title">
            <span>Maintenance</span>
            <h3>Manual system control</h3>
          </div>
          <div className="support-panel-icon">
            <FaCogs />
          </div>
        </div>

        <div className="support-routing-action-card">
          <div>
            <strong>Rebalance queues</strong>
            <p>Ask the system to rebalance routing based on the current queue state.</p>
          </div>
          <button
            className="support-primary-btn"
            onClick={runRebalance}
            disabled={rebalanceLoading}
          >
            {rebalanceLoading ? (
              <>
                <FaSpinner className="support-loading" />
                Running
              </>
            ) : (
              <>
                <FaRetweet />
                Rebalance
              </>
            )}
          </button>
        </div>

        <div className="support-routing-action-card">
          <div>
            <strong>Refresh live routing data</strong>
            <p>Pull the latest queue topology, mapping, and health values.</p>
          </div>
          <button className="support-secondary-btn" onClick={() => loadRoutingData(true)}>
            <FaSyncAlt />
            Refresh now
          </button>
        </div>
      </div>

      <div className="support-panel">
        <div className="support-panel-header">
          <div className="support-panel-title">
            <span>Quick snapshot</span>
            <h3>Current routing status</h3>
          </div>
          <div className="support-panel-icon">
            <FaCheckCircle />
          </div>
        </div>

        <div className="support-routing-snapshot-list">
          <div className="support-routing-snapshot-item">
            <span>Total queues</span>
            <strong>{overviewStats.totalQueues}</strong>
          </div>
          <div className="support-routing-snapshot-item">
            <span>Active tickets</span>
            <strong>{overviewStats.totalActive}</strong>
          </div>
          <div className="support-routing-snapshot-item">
            <span>Escalated tickets</span>
            <strong>{overviewStats.totalEscalated}</strong>
          </div>
          <div className="support-routing-snapshot-item">
            <span>SLA breached</span>
            <strong>{overviewStats.totalBreached}</strong>
          </div>
        </div>
      </div>
    </div>
  );

  if (loading) {
    return (
      <div className="support-loader">
        <div className="support-loader-card">
          <FaSpinner className="support-loading" />
          <h2>Loading Routing</h2>
          <p>Preparing queue topology and routing controls...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="support-page">
      <div className="support-header">
        <div className="support-header-content">
          <div className="support-live-tag">
            <span className="support-live-dot" />
            ROUTING CONTROL CENTER
          </div>

          <h1>Routing</h1>
          <p>
            Manage queue topology, category mapping, escalation flow, and live routing health.
          </p>
        </div>

        <div className="support-header-actions">
          <button
            className="support-refresh-btn"
            onClick={() => loadRoutingData(true)}
            disabled={refreshing}
            type="button"
          >
            <FaSyncAlt className={refreshing ? "support-loading" : ""} />
            {/* {refreshing ? "Refreshing" : "Refresh"} */}
          </button>

          {/* <div className="support-kpi-pill">
            <FaUserShield />
            Super Admin
          </div> */}
        </div>
      </div>

      {notice ? (
        <div
          className={`support-routing-notice ${notice.type === "success"
              ? "success"
              : notice.type === "warn"
                ? "warn"
                : "error"
            }`}
        >
          {notice.text}
        </div>
      ) : null}

      <div className="support-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`support-tab ${activeTab === tab.key ? "is-active" : ""}`}
            onClick={() => setActiveTab(tab.key)}
            type="button"
          >
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "overview" && renderOverview()}
      {activeTab === "map" && renderMap()}
      {activeTab === "simulate" && renderSimulator()}
      {activeTab === "health" && renderHealth()}
      {activeTab === "chain" && renderChain()}
      {activeTab === "actions" && renderActions()}
    </div>
  );
}